import React from 'react';
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal,
} from '@mui/material';
import styles from './ModalStyle.module.scss';
import { ComponentEquipmentReturnInterface } from '../../utils/types';
import { EquipmentReturnIcon } from '../../../../assets/Icons/InventoryIcons/EquipmentReturnIcon';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 497,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
export default function ComponentEquipmentReturn({
  show, setOpenFrom, onClickYes, products,
}: ComponentEquipmentReturnInterface): JSX.Element {
  // const { inventoryData } = useSelector((state: RootState) => state.inventoryReducer);

  // const EquipmentReturnText = useCallback(() => {
  //   const openedFormData = inventoryData?.Data?.find((row: InventoryData) => Number(row.ProductNumber) === Number(rowId));
  //   return `Return  Product ${rowId} From ${openedFormData?.AnalystName}?`;
  // }, [rowId, inventoryData]);

  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.EquipmentReturnIcon}>
          <EquipmentReturnIcon />
        </div>
        <div
          style={{
            color: '#000000',
          }}
          className={styles.modalModalDescription}
        >
          Are you sure you want to return the below equipments?
        </div>
        <div style={{ marginTop: '-20px' }}>
          <TableContainer component={Paper} elevation={4} style={{ maxHeight: '40vh' }}>
            <Table
              size="small"
              sx={{
                '& .MuiTableCell-root': {
                  fontSize: '12px',
                  padding: '6px 8px',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell><strong>Product #</strong></TableCell>
                  <TableCell><strong>Issued to</strong></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {products?.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.analystName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className={styles.divButtons} style={{ marginTop: '20px' }}>
          <button
            type="button"
            className={`btn ${styles.yesBtn}`}
            onClick={() => {
              if (onClickYes) {
                onClickYes();
              }
            }}
          >
            Yes
          </button>
          <button type="button" className={`btn ${styles.noBtn}`} onClick={setOpenFrom}>No</button>
        </div>
      </Box>
    </Modal>
  );
}
